import React from 'react'
import styled from 'styled-components'

const TextContainer = styled.g`
  &:hover .shadow {
    fill: #ff56ff;
    fill-opacity: .7;
  }
`

const TitleText = styled.text`
  font-family: 'Helvetica', sans-serif;
  fill: blue;
  stroke: white;
  stroke-width: 2;
  font-size: 72px;
  font-weight: bold;
  text-transform: uppercase;
`

const TitleShadow = TitleText.extend.attrs({
  className: 'shadow'
})`
  fill: #ff56ff;
  stroke: none;
`

const ShadowTitleText = (props) => {
  const { x, y, text } = props
  const offset = 3.5
  return (
    <TextContainer transform="scale(1)">
      <TitleShadow x={x - offset} y={y + offset}>{text}</TitleShadow>
      <TitleText x={x} y={y}>{text}</TitleText>
    </TextContainer>
  )
}

class PageTitle extends React.Component {

  render() {
    return (
      <div style={{ maxWidth: '600px' }}>
        <svg viewBox="0 0 550 100">
          <ShadowTitleText
            y={85}
            x={10}
            text="hacks.cheap"
          />
        </svg>
      </div>
    )
  }
}

export default PageTitle



// WEBPACK FOOTER //
// ./src/components/PageTitle.js